// extracted by mini-css-extract-plugin
module.exports = {"auditReportTable":"AuditReportTable_auditReportTable__VyFKl"};